export default "__VITE_ASSET__CDD$Upcs__"